// extracted by mini-css-extract-plugin
module.exports = {"button":"LimitButton_button__3uiCB","active":"LimitButton_active__E_AVn"};